import React, { useEffect } from "react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

const TabNav = ({ block }) => {
  let currentUrl = ""

  if (typeof window !== "undefined") {
    currentUrl = window.location.pathname
  }

  return (
    <section className="w-full border-b border-gray-300">
      <div className="pt-4 mx-auto block-w-container">
        <nav className="flex flex-row flex-wrap justify-center -mx-1">
          {block.subNavItems?.map((item, index) => (
            <div className="px-1" key={index}>
              <Link
                className={`block px-4 py-2 rounded-t-xl ${
                  currentUrl === item.link ||
                  currentUrl.replace(/.$/, "") === item.link
                    ? "bg-primary text-white pointer-events-none"
                    : "text-primary"
                }  transition-colors duration-300 hover:bg-gray-300 `}
                link={item.link}
              >
                {item.link_text}
              </Link>
            </div>
          ))}
        </nav>
      </div>
    </section>
  )
}

export default TabNav
